import { useEffect } from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { User } from '~/contexts/UserAuthProvider';

declare global {
  interface Window {
    heap: any;
  }
}

const getHeapScript = (heapAppId: string | number) => `
window.heap = window.heap || [], heap.load = function(e, t) {
  window.heap.appid = e, window.heap.config = t = t || {};
  var r = document.createElement("script");
  r.type = "text/javascript", r.async = !0, r.src = "https://cdn.heapanalytics.com/js/heap-" + "${heapAppId}" + ".js";
  var a = document.getElementsByTagName("script")[0];
  a.parentNode.insertBefore(r, a);
  for (var n = function(e) {
          return function() {
              if (!heap || !heap.push) return;
              heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
          }
      }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], o = 0; o < p.length; o++) heap[p[o]] = n(p[o])
};
heap.load("${heapAppId}");
`;

/**
 * Hook to impelment heap in dashboard, skip in development
 * @param heapAppId HEAP_APP_ID for customer dashboard
 */
export const useHeap = (heapAppId: string | number) => {
  useEffect(() => {
    // NODE_ENV is global - not sure we can use envUtils.isNotDevelopment()
    if (NODE_ENV !== 'development') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = getHeapScript(heapAppId);
      document.head.appendChild(script);
    }
  }, [heapAppId]);
};

/**
 * Method to identify user by user.id and add user properties to heap identity
 * @param dashboardType borrower | capitalProvider, can be extended in the future to other dashboard types
 * @param user GetUserGQLType response
 */
export const heapIdentify = ({
  user,
  dashboardType,
}: {
  dashboardType:
    | 'admin'
    | 'borrower'
    | 'capitalProvider'
    | 'securitiesProvider'
    | 'unknown';
  user: User;
}) => {
  const { id, email, organization, roleType } = user;
  window.heap.identify(id);
  window.heap.addUserProperties({
    dashboardType,
    roleType,
    organizationId: organization.id,
    industry: organization.industry,
    organizationName: organization.name,
    organizationSlug: organization.slug,
    testUser: commonUtils.isFinleyTestUserEmail(email).toString(),
  });
};
